import React, { useEffect, useState } from 'react';
import forOwn from 'lodash/forOwn';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import {
  Button,
  DropdownMenu,
  Icon,
  TextInput,
  Modal,
} from '@paypalcorp/pp-react';
import * as analytics from '../lib/analytics';
import styles from './searchBox.less';

const SearchBox = (
  {
    categories,
    states,
    isMobile,
    i18n,
    fptiInfo,
    charityListUnderThreshold,
    searchSubmitUrl,
  },
  ...props
) => {
  const [keywords, setKeywords] = useState('');
  const [stateIndex, setStateIndex] = useState(-1);
  const [categoryIndex, setCategoryIndex] = useState(-1);
  const [enableOpen, setEnableOpen] = useState(false);
  const [isMobileModalOpened, setIsMobileModalOpened] = useState(false);
  const [categoryValueOptions, setCategoryValueOptions] = useState([]);
  const [stateValueOptions, setStateValueOptions] = useState([]);

  const trackData = () => {
    let category, state;
    if (
      !isEmpty(categoryIndex) &&
      !isEmpty(categoryValueOptions[categoryIndex])
    ) {
      category = categoryValueOptions[categoryIndex].value;
    }
    if (!isEmpty(stateIndex) && !isEmpty(stateValueOptions[stateIndex])) {
      state = stateValueOptions[stateIndex].value;
    }
    analytics.trackLinkWithData(
      'SearchButton',
      fptiInfo.pgrp,
      fptiInfo.page,
      {
        query: keywords,
        category,
        state,
      },
      'link'
    );
  };

  const renderUpdateDimentions = () => {
    if (window.innerWidth <= 712) {
      setEnableOpen(true);
    } else {
      setEnableOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', renderUpdateDimentions);
    renderUpdateDimentions();
  }, []);

  useEffect(() => {
    let options;
    if (Array.isArray(categories)) {
      const categoryIDs = uniq(categories.map((ca) => ca.id));
      options = categoryIDs.map((id) => ({
        value: String(id),
        primaryText: i18n(`label.category-${id}`),
      }));
    } else {
      options = [];
    }

    setCategoryValueOptions(options);
  }, [categories]);

  useEffect(() => {
    const options = [];
    forOwn(states, (value, key) => {
      options.push({
        value: key,
        option: value,
      });
    });
    setStateValueOptions(options);
  }, [states]);

  const onFormSubmitted = () => {
    let url;
    if (!isEmpty(searchSubmitUrl)) {
      url = new URL(window.location.origin);
      url.pathname = searchSubmitUrl;
    } else {
      url = new URL(window.location.href);
    }
    const search = new URLSearchParams();
    search.append('keywords', keywords || '');
    if (categoryIndex > -1 && !isEmpty(categoryValueOptions[categoryIndex])) {
      search.append('category', categoryValueOptions[categoryIndex].value);
    }
    if (stateIndex > -1 && !isEmpty(stateValueOptions[stateIndex])) {
      search.append('state', stateValueOptions[stateIndex].value);
    }
    url.search = search;
    window.location = url;
  };

  const onKeywordChanged = (e) => setKeywords(e.target.value);
  const onCategoryChanged = (index) => setCategoryIndex(index);
  const onStateChanged = (index) => setStateIndex(index);

  const renderModalBody = () => (
    <form
      className={'formStyle'}
      onSubmit={(e) => {
        e.preventDefault();
        onFormSubmitted();
      }}
    >
      <div className={'modalbodyContent'}>
        <div>
          <div className={'searchBox searchBoxMobileModal'}>
            <TextInput
              type={'text'}
              name='keywords'
              className={styles['ppvx_text-input']}
              autoComplete='off'
              value={keywords}
              onChange={onKeywordChanged}
              placeholder={i18n('label.search-placeholder-modal')}
            />
          </div>
          {categoryValueOptions.length > 0 && !charityListUnderThreshold && (
            <div className={'selectCategory selectMobileModal'}>
              <DropdownMenu
                label={i18n('label.search-category')}
                placeholder=''
                options={categoryValueOptions}
                onSelection={onCategoryChanged}
                selectedItemIndex={categoryIndex}
                name='category'
                required={false}
              />
            </div>
          )}
          {stateValueOptions.length > 0 && (
            <div className={'selectState selectMobileModal'}>
              <DropdownMenu
                label={i18n('label.search-state')}
                placeholder=''
                options={stateValueOptions.map((s) => ({
                  primaryText: s.option,
                  value: s.value,
                }))}
                onSelection={onStateChanged}
                selectedItemIndex={stateIndex}
                name='state'
                required={false}
              />
            </div>
          )}
        </div>
        <div className={'searchButtonModal'}>
          <span className={''}>
            <Button type={'submit'}>{i18n('label.search-button')}</Button>
          </span>
        </div>
      </div>
    </form>
  );

  return (
    <div className={'searchContainer containerCust'}>
      <form
        className={'formStyle input-group'}
        onSubmit={(e) => {
          e.preventDefault();
          onFormSubmitted();
        }}
      >
        <div className={'row innerSearchContainer'}>
          <div className={'searchBoxContainer'}>
            <div className={'searchBox'}>
              {!enableOpen && !isMobile && (
                <TextInput
                  name='keywords'
                  autoComplete='off'
                  maxLength={'256'}
                  value={keywords}
                  id={'inputBoxSearchBar'}
                  onChange={onKeywordChanged}
                  label={i18n('label.search-placeholder')}
                  leftIcon={<Icon size='sm' name='search' />}
                />
              )}
              {(enableOpen || isMobile) && (
                <TextInput
                  onClick={() => setIsMobileModalOpened(true)}
                  name='keywords'
                  autoComplete='off'
                  maxLength={'256'}
                  value={keywords}
                  id={'inputBoxSearchBar'}
                  onFocus={() =>
                    document.getElementById('inputBoxSearchBar').blur()
                  }
                  onChange={onKeywordChanged}
                  label={i18n('label.search-placeholder-modal')}
                  leftIcon={<Icon size='sm' name='search' />}
                />
              )}
            </div>
            <div className={'selectContainer'}>
              {categoryValueOptions.length > 0 && !charityListUnderThreshold && (
                <div className={'selectCategory changedisplay'}>
                  <DropdownMenu
                    label={i18n('label.search-category')}
                    placeholder=''
                    options={categoryValueOptions}
                    onSelection={onCategoryChanged}
                    selectedItemIndex={categoryIndex}
                    name='category'
                    required={false}
                  />
                </div>
              )}
              {stateValueOptions.length > 0 && (
                <div className={'selectState changedisplay'}>
                  <DropdownMenu
                    label={i18n('label.search-state')}
                    placeholder=''
                    options={stateValueOptions.map((s) => ({
                      primaryText: s.option,
                      value: s.value,
                    }))}
                    onSelection={onStateChanged}
                    selectedItemIndex={stateIndex}
                    name='state'
                    required={false}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={'searchbuttonContainer'}>
            <span>
              <Button id={'nemo_searchButton'} onClick={trackData} size='lg'>
                {i18n('label.search-button')}
              </Button>
            </span>
          </div>
        </div>
      </form>
      <Modal
        overpanel
        closeOnBackgroundClick={true}
        center
        id='searchBox'
        isOpen={isMobileModalOpened}
        onClose={() => setIsMobileModalOpened(false)}
      >
        {enableOpen && renderModalBody()}
      </Modal>
    </div>
  );
};

export default SearchBox;
